export default __webpack_public_path__ + "static/media/icon.fa4e0c00.png";